import { isEmpty } from "../../Utils/utils";

const DynamicTable = ({ specs }) => {

  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <tbody>
        {specs.map((spec, index) => (
          !isEmpty(spec.value) &&
          <tr
            key={index}
            style={{
              borderBottom: "1px solid #ccc",
            }}
          >
            <td
              style={{
                padding: "10px",
                width: "50%",
                color: "var(--dark-background-color)",
                verticalAlign: "top",
                fontWeight: "bold",
                fontFamily: 'Source Sans Pro',
              }}
            >
              {spec.header}
            </td>
            <td style={{ padding: "10px" }}>
              {!isEmpty(spec.code) && <div style={{
                width: 20,
                height: 20,
                backgroundColor: spec.code,
                border: "1px solid #ccc",
                borderRadius: 4,
                color: "var(--dark-background-color)",
                fontFamily: 'Source Sans Pro',
              }} />}
              {spec.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DynamicTable;
